import React, { useMemo } from "react";
import {
  Box,
  Button,
  Modal,
  ModalClose,
  ModalDialog,
  Typography,
} from "@mui/joy";
import type { TaskEditorState } from "../utils/taskEditorUtils";
import {
  DiffCodeLines,
  diffOrderedJson,
  JSON_CODE_PRE_SX,
} from "../jsonCodeView";

interface TurnDiffModalProps {
  open: boolean;
  taskBefore: TaskEditorState;
  taskAfter: TaskEditorState;
  onClose: () => void;
}

export function TurnDiffModal({
  open,
  taskBefore,
  taskAfter,
  onClose,
}: TurnDiffModalProps) {
  const lines = useMemo(
    () => diffOrderedJson(taskBefore.blocks, taskAfter.blocks),
    [taskBefore, taskAfter]
  );

  return (
    <Modal open={open} onClose={onClose}>
      <ModalDialog
        sx={{
          minWidth: 600,
          maxWidth: "min(90vw, 900px)",
          maxHeight: "85vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 1,
            mb: 1,
          }}
        >
          <Typography level="title-md" sx={{ fontWeight: 700 }}>
            이번 턴의 변경 내용
          </Typography>
          <ModalClose sx={{ position: "static" }} />
        </Box>
        <Box component="pre" sx={JSON_CODE_PRE_SX}>
          <DiffCodeLines lines={lines} />
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 1,
            mt: 1.5,
          }}
        >
          <Button size="sm" variant="Plain" color="primary" onClick={onClose}>
            확인
          </Button>
        </Box>
      </ModalDialog>
    </Modal>
  );
}
